import React from 'react'

const Header = () => {
  return (
    <div>
      <h2>Expense Tracker</h2>
    </div>
  )
}

export default Header
